import { initiateVueIslands } from '@uselab/vue-islands';
import clickOutside from '@/composition/click-outside';
import { components } from '@/composition/semantic-html/components';

import '@/bundles/main.scss';

initiateVueIslands(components, {
  isDevMode: import.meta.env.DEV,
  configureApp: async (app) => {
    app.directive('click-outside', clickOutside);
  },
});
